<template>

    <div class="wrap _full">
        <div class="inner">

            <section>

                <div class="talk_component">
                    <div class="wrap">
                        <div class="talk-inner">

                            <!--:::::::::::::::::::::::::::::::::::::::::::::::

                                BubbleArea

                            :::::::::::::::::::::::::::::::::::::::::::::::::-->
                            <template v-for="mes in messageList" :key="mes.id">

                                <!-- Bubble -->
                                <div class="bubble-item" v-bind:class="{ '_my-bubble': mes.check }" >
                                    <div class="avatar-wrap">
                                        <img v-if="mes.user.icon" :src="$store.state.const.AWS_S3_URL_HOST + mes.user.icon" alt="" class="avatar">
                                        <div v-if="!mes.user.icon" class="btn_svg-icon avatar">
                                            <SvgIconImagePlace />
                                        </div>
                                    </div>
                                    <div class="bubble-wrap">
                                        <time>{{mes.user.name}}</time>
                                        <div class="bubble-body">
                                            <p><span>{{mes.text}}</span></p>
                                            <template v-if="mes.file_path">
                                                <br />
                                                <a v-bind:href="$store.state.const.AWS_S3_URL_HOST + mes.file_path ">
                                                    <p>{{ mes.file_path_name }}</p>
                                                    <span>
                                                        <img v-bind:src="$store.state.const.AWS_S3_URL_HOST + mes.file_path" alt="">
                                                    </span>
                                                </a>
                                            </template>
                                        </div>
                                        <time>{{formatDate(mes.created_at)}}</time>
                                    </div>
                                </div>
                            </template>
                            <!--:::::::::::::::::::::::::::::::::::::::::::::::

                                /BubbleArea

                            :::::::::::::::::::::::::::::::::::::::::::::::::-->

                        </div><!-- /Inner -->

                        <!-- Control -->
                        <div class="control-wrap">

                            <div class="fab-wrap">
                                <div>
                                    <a class="fab _back" :href="route(routeName)">
                                        <div class="md_svg-icon">
                                            <SvgIconBack />
                                        </div>
                                    </a>
                                </div>
                                <!-- <div>
                                    <p><span>運営に報告する</span></p>
                                    <button class="fab">
                                        <div class="md_svg-icon _white">
                                            <SvgIconExclamation />
                                        </div>
                                    </button>
                                </div> -->
                            </div>

                            <div class="input-wrap">
                                <div class="talk-inner">
                                    <div class="input-row">

                                        <label for="talk-files1" class="_add btn_svg-icon">
                                            <SvgIconAdd />
                                        </label>
                                        <template v-if="file_name_check">
                                            <div class="file-name js-upload-filename"></div>
                                            <div class="file-name-bubble"></div>
                                            <div class="file-clear btn_svg-icon _white" v-on:click="imageCancel">
                                                <SvgIconCancel />
                                            </div>
                                        </template>

                                        <input type="file" id="talk-files1" name="talk-files" class="js-upload-file" v-on:change="confirmImage" ref="file"/>

                                        <textarea maxlength="250" name="" id="fileIcon" v-model="message"></textarea>
                                        <button style=" margin-bottom: 0; height: 49px;" type="button" v-on:click="send()"><span>SEND</span></button>
                                    </div>
                                </div>
                            </div>

                        </div><!-- /Control -->

                    </div><!-- /Wrap -->
                </div><!-- /TalkComponent -->
            </section>
        </div><!--/.ly_main .inner-->
    </div><!--/.ly_main .wrap-->
    <AlertModal 
        v-if="showAlertModal" 
        @close="closeAlertModal" 
        :title="alert_modal_title" 
        :message="alert_modal_message"
        :mode="alert_modal_mode" 
    />
</template>

<script>
    import { Inertia } from '@inertiajs/inertia'
    import { reactive } from 'vue'
    import AlertModal from '@/components/Admin/ComponentList/AlertModal'
    import dayjs from 'dayjs'

    //ScrollTrigger
    import gsap from 'gsap';
    import { ScrollTrigger } from "gsap/ScrollTrigger";
    gsap.registerPlugin(ScrollTrigger);

    //Svg
    import SvgIconExclamation from '@/components/EndUser/svg/SvgIconExclamation'
    import SvgIconImagePlace from '@/components/EndUser/svg/SvgIconImagePlace'
    import SvgIconFolder from '@/components/EndUser/svg/SvgIconFolder'
    import SvgIconBack from '@/components/EndUser/svg/SvgIconBack'
    import SvgIconCancel from '@/components/EndUser/svg/SvgIconCancel'
    import SvgIconAdd from '@/components/EndUser/svg/SvgIconAdd'

    export default {
        components: {
            "AlertModal": AlertModal,
            //Svg
            SvgIconExclamation,
            SvgIconImagePlace,
            SvgIconFolder,
            SvgIconBack,
            SvgIconCancel,
            SvgIconAdd,
        },
        props: {
            messages: Object,
            shop_id: Object,
            brand_id: Object,
            showroom_id: Object,
            chat_room_id: Object,
        },
        data: function() {
            return {
                message: '',
                file: '',
                url: '',
                file_name_check: false,
                showAlertModal: false,
                alert_modal_title: "",
                alert_modal_message: "",
                alert_modal_mode: ""
            }
        },
        mounted() {

            ////////////////////////////////////
            // ページが読み込まれたら ScrollTrigger.js の トリガー位置を再計算する
            ////////////////////////////////////
            window: onload = function () {
                ScrollTrigger.refresh(true);
            },

            ////////////////////////////////////
            // 発言入力エリアを部分的に固定する
            ////////////////////////////////////
            ScrollTrigger.create({
                trigger: ".talk_component .control-wrap",
                start: "bottom 100%",
                endTrigger: ".talk_component",
                end: "bottom 100%",
                pin: true,
                pinSpacing: false,
            });

            ////////////////////////////////////
            // 追加 ファイル名を表示させる
            ////////////////////////////////////
            $('.js-upload-file').on('change', function () { //ファイルが選択されたら
                var file = $(this).prop('files')[0]; //ファイルの情報を代入(file.name=ファイル名/file.size=ファイルサイズ/file.type=ファイルタイプ)
                $('.js-upload-filename').text(file.name); //ファイル名を出力
            });

            // 初期表示を一番下にする
            var $this = this;
            this.$nextTick(() => {
                var elm = document.documentElement;
                //scrollHeight ページの高さ clientHeight ブラウザの高さ
                var bottom = elm.scrollHeight - elm.clientHeight;
                //垂直方向へ移動
                window.scrollTo({
                    top: bottom,
                    behavior:'smooth'
                })
            });

            this.url = location.pathname;
            Echo.channel('chat')
                .listen('MessageCreated', (e) => {
                    if (e.showroom_id) {
                        var form = {
                            showroom_id: e.showroom_id,
                            brand_id: e.brand_id,
                        }
                    } else {
                        var form = {
                            shop_id: e.shop_id,
                            brand_id: e.brand_id,
                        }
                    }
                    Inertia.get(this.url, form, {
                        preserveScroll: true,
                    })
                });
        },
        computed: {
            messageList() {
                for(var i in this.messages) {
                    var message = this.messages[i];
                    if(message.file_path) {
                        var name = message.file_path.split('/');
                        message.file_path_name = name[3];
                    }
                }
                return this.messages;
            },
            routeName() {
                if (location.pathname == '/admin/brand/talk') { //ブランドの場合
                    return 'admin.brand.shops';
                } else if (location.pathname == '/admin/shop/talk') { //ショップの場合
                    return 'admin.shop.brands';
                } else if (location.pathname == '/admin/showroom/talk') { //ショールームとショップの場合
                    return 'admin.showroom.shops';
                }
            }
        },
        methods: {
            formatDate: dateStr => dayjs(dateStr).format('YYYY/MM/DD HH:mm'),
            send() {
                const form = reactive({
                    message: this.message,
                    file: this.file,
                    file_name: this.file.name,
                    shop_id: this.shop_id,
                    brand_id: this.brand_id,
                    showroom_id: this.showroom_id,
                    chat_room_id: this.chat_room_id,
                })
                Inertia.post(this.url, form, {
                    // preserveScroll: true,
                    onError: (errors) => {
                        if (errors.message) {
                            this.openAlertModal('error', 'エラー', 'メッセージを正しく入力してください'); //確認済み
                        }
                    },
                    onSuccess: (page) => {
                        this.message = '';
                        this.file = '';
                        this.$refs.file.value = '';
                    },
                })
            },
            confirmImage(e) {
                this.file_name_check = true;
                const files = e.target.files;
                const file = files[0];
                if (file.size > this.$store.state.const.max_file_size) {
                    this.$refs.file.value = '';
                    this.openAlertModal('error', 'エラー', this.$store.state.const.file_size_error); //確認済み
                } else {
                    this.file = file;
                }
            },
            imageCancel() {
                this.file_name_check = false;
                this.$refs.file.value = '';
                this.file = '';
            },
            openAlertModal(mode, title, message) {
                this.alert_modal_mode = mode;
                this.alert_modal_title = title;
                this.alert_modal_message = message;
                this.showAlertModal = true;
            },
            closeAlertModal() {
                this.showAlertModal = false;
                this.alert_modal_mode = "";
                this.alert_modal_title = "";
                this.alert_modal_message = "";
            }
        }
    }
</script>

<style>
p {
    white-space: pre-wrap;
}

.modal_container {
    margin-left: 140px;
}
</style>